import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  Button,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import InterestsIcon from "@mui/icons-material/Interests";
import "./Profile.css";

const InterestsSection = ({ interests, onEdit }) => {
  const hasInterests = interests && Array.isArray(interests) && interests.length > 0;

  return (
    <Card elevation={1} sx={{ borderRadius: 2 }}>
      <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: { xs: 2, sm: 3 },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <InterestsIcon color="primary" sx={{ fontSize: { xs: "1.2rem", sm: "1.5rem" } }} />
            <Typography
              variant="h6"
              sx={{ fontWeight: 600, fontSize: { xs: "1rem", sm: "1.25rem" } }}
            >
              My Interests
            </Typography>
          </Box>
          <Button
            variant="outlined"
            size="small"
            startIcon={<EditIcon />}
            onClick={onEdit}
            sx={{ ml: 2 }}
          >
            Edit
          </Button>
        </Box>

        {hasInterests ? (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
              mt: 2,
            }}
          >
            {interests.map((interest, index) => (
              <Chip
                key={index}
                label={interest}
                color="primary"
                variant="outlined"
                sx={{
                  fontSize: { xs: "0.75rem", sm: "0.875rem" },
                }}
              />
            ))}
          </Box>
        ) : (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              py: 3,
              textAlign: "center",
            }}
          >
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              No interests selected yet. Select your interests to get personalized content recommendations.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<EditIcon />}
              onClick={onEdit}
            >
              Select Interests
            </Button>
          </Box>
        )}

        <Typography variant="body2" color="text.secondary" sx={{ mt: 2, fontStyle: "italic" }}>
          Your interests help us recommend personalized content for you.
        </Typography>
      </CardContent>
    </Card>
  );
};

export default InterestsSection;





